<template>
  <div class="bj-section">
    <div class="ubold-title" style="margin-bottom: 40px">个人认证</div>
    <div class="bj-search-section">
      <div class="bj-search-row">
        <div class="item">
          <div class="name" style="margin-right: 10px">姓名：</div>
          <Input
            class="bj-input-26262A bj-input-h45"
            v-model="username"
            placeholder="请输入搜索的名称"
            style="width: 300px"
            clearable
          />
        </div>
        <div class="item" style="margin-left: 20px;">
          <Button
            class="bj-search-btn-F85A36"
            type="primary"
            style="margin-right: 20px;"
            @click="onSearch"
            >搜索</Button
          >
          <Button
            class="bj-border-F85A36"
            @click="onSearchCancel"
            style="margin-right: 20px"
            >重置</Button
          >
          <Button
            class="bj-border-F85A36"
            @click="updateCertifiedModalVisibility = true"
            >添加个人认证</Button
          >
        </div>
      </div>
    </div>
    <div class="bj-table-data">
      <div class="total">搜索结果<span class="count">（{{ total }}）</span></div>
      <Table
        class="bj-2F3033-table"
        stripe
        :columns="columns"
        :data="data"
        :loading="tableLoading"
      >
        <template slot="certificateStatus" slot-scope="{ row }">
          <div>
            {{ row.status | status }}
          </div>
        </template>
        <template slot="action" slot-scope="{ row }">
          <div v-if="row.real === 0" class="bj-rows">
            <div class="table-btn" @click="onDeleteItem(row)">删除</div>
          </div>
          <div v-else>--</div>
        </template>
      </Table>
      <div class="page-tool">
        <Page
          class="pages"
          :current="page"
          :total="total"
          :page-size="limit"
          show-total
          show-sizer
          show-elevator
          @on-change="onPageChange"
          @on-page-size-change="onPageSizeChange"
        />
      </div>
    </div>
    <updateCertifiedModal
      :show.sync="updateCertifiedModalVisibility"
      @submit-success="onSuccess"
    ></updateCertifiedModal>
  </div>
</template>

<script>
import { userIdentityList, userIdentityDelete } from "api/user.js";
import updateCertifiedModal from "components/account/updateCertifiedModal.vue";

export default {
  name: "myPersonal",
  components: {
    updateCertifiedModal,
  },
  filters: {
    status(val) {
      let title = "";
      switch (val) {
        case 0:
          title = "认证中";
          break;
        case 1:
          title = "认证成功";
          break;
        case 2:
          title = "认证失败";
          break;
      }
      return title;
    },
  },
  data() {
    return {
      username: "",
      page: 1,
      limit: 20,
      total: 0,
      columns: [
        {
          width: 100,
          title: "姓名",
          align: "center",
          key: "name",
        },
        {
          title: "证件类型",
          align: "center",
          key: "t",
          render: (h, { row }) => {
            return h("div", row.t === 0 ? "身份证" : "护照");
          },
        },
        {
          title: "证件号码",
          align: "center",
          key: "sfz",
        },
        {
          width: 180,
          title: "提交时间",
          align: "center",
          key: "createdTime",
        },
        {
          title: "状态",
          align: "center",
          slot: "certificateStatus",
        },
        {
          title: "操作",
          align: "center",
          slot: "action",
        },
      ],
      data: [],
      tableLoading: false,
      updateCertifiedModalVisibility: false,
    };
  },
  created() {
    this.req_getList();
  },
  methods: {
    // 请求
    async req_getList() {
      try {
        const params = {
          n: this.username,
          page: this.page,
          limit: this.limit,
        };
        this.tableLoading = true;
        const { code, data } = await userIdentityList(params);
        this.tableLoading = false;
        if (code === 200) {
          this.data = data.list;
          this.total = data.total;
        }
      } catch (error) {
        this.tableLoading = false;
        console.log(error);
      }
    },
    // 跳页
    onPageChange(val) {
      this.page = val;
      this.req_getList();
    },
    // 页大小
    onPageSizeChange(val){
      this.limit = val;
      this.req_getList();
    },
    // 搜索
    onSearch() {
      this.onPageChange(1);
    },
    // 重置
    onSearchCancel() {
      this.username = "";
      this.onPageChange(1);
    },
    async onSuccess(callback) {
      await this.req_getList();
      callback(true);
    },
    // 取消转出
    onDeleteItem(val) {
      this.$Modal.confirm({
        title: "删除确认",
        content: "<p>确定要删除此个人认证吗？</p>",
        onOk: async () => {
          const res = await userIdentityDelete(val.id);
          const { code, result } = res;
          if (code === 200 && result) {
            this.$Message.success("删除成功！");
            this.req_getList();
          }
        },
      });
    },
  },
};
</script>
<style lang="less" scoped>
.bj-search-section{
    background-color: #28292C;
    padding: 14px 28px;
    border-radius: 6px;
    .bj-search-row{
      display: flex;
      .item{
        display: flex;
        align-items: center;
        .name{
          color: #fff;
        }
      }
    }
  }
</style>
